import { render, staticRenderFns } from "./BulkUpload.vue?vue&type=template&id=4e86681a"
import script from "./BulkUpload.vue?vue&type=script&lang=js"
export * from "./BulkUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports